import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import dayjs from "dayjs";

Font.register({
  family: "Manrope",
  fonts: [
    { src: "/fonts/Manrope-Regular.ttf", fontWeight: "normal" },
    { src: "/fonts/Manrope-Bold.ttf", fontWeight: "bold" },
    { src: "/fonts/Manrope-Medium.ttf", fontWeight: "medium" },
  ],
});

const COL = {
  empId: 0.7,
  name: 1.6,
  jobTitle: 1.4,
  department: 1.2,
  division: 1.4,
  time: 1.0,
  joinDate: 1.0,
  status: 0.8,
  nationality: 1.0,
  mobile: 1.0,
};

const styles = StyleSheet.create({
  page: {
    padding: 20,
    paddingBottom: 90,
    fontSize: 10,
    fontFamily: "Manrope",
  },
  headerSpace: {
    height: 80,
    // borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    marginBottom: 10,
  },
  header_image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  centerDiv: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 12,
  },
  mainTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 4,
  },
  smallText: {
    fontSize: 9,
    color: "grey",
    marginBottom: 8,
  },
  tableHeader: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    paddingVertical: 5,
    paddingHorizontal: 8,
    backgroundColor: "#2663EB",
    color: "#ffffff",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
    paddingVertical: 4,
    alignItems: "flex-start",
  },
  cell: {
    fontSize: 8,
  },

  cellBold: {
    fontSize: 8,
    fontWeight: "bold",
  },
  cellGreen: {
    fontSize: 8,
    color: "green",
  },
  cellRed: {
    fontSize: 8,
    color: "red",
  },
  //   footerSpace: {
  //     position: "absolute",
  //     bottom: 24,
  //     left: 0,
  //     right: 0,
  //     height: 60,
  //   },
  //   footer_image: {
  //     width: "100%",
  //     height: 60,
  //     objectFit: "cover",
  //   },
  //   footerRow: {
  //     position: "absolute",
  //     bottom: 88,
  //     left: 20,
  //     right: 20,
  //     flexDirection: "row",
  //     justifyContent: "center",
  //     borderTopWidth: 1,
  //     borderTopColor: "#ccc",
  //     paddingTop: 5,
  //   },
  //   footer: {
  //     fontSize: 9,
  //     color: "grey",
  //   },
  footerPageNum: {
    position: "absolute",
    bottom: 6,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 9,
    color: "grey",
  },

  // Footer image sits just above the page number
  footerSpace: {
    position: "absolute",
    bottom: 22,
    left: 0,
    right: 0,
    height: 80,
  },
  footer_image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
});

const AbsenceReportDocument = ({ absenceReportPrintData }) => {
  console.log("absenceReportPrintData:", absenceReportPrintData);

  const bondTimeportNoData = JSON.parse(
    localStorage.getItem("BondTimeportNoData") || "[]",
  );

  const headerImage = bondTimeportNoData[0]?.REP_HEADER;
  const footerImage = bondTimeportNoData[0]?.REP_FOOTER;

  const totalCount = absenceReportPrintData?.length || 0;

  console.log("absenceReportPrintData:", absenceReportPrintData);

  const columns = [
    { key: "EMP ID", flex: COL.empId, bold: false },
    { key: "NAME", flex: COL.name, bold: true },
    { key: "JOB TITLE", flex: COL.jobTitle, bold: false },
    { key: "DEPARTMENT", flex: COL.department, bold: false },
    { key: "DIVISION", flex: COL.division, bold: false },
  ];

  const groupedData = absenceReportPrintData?.reduce((acc, r) => {
    const key = r["EMP ID"];
    if (!acc[key]) {
      acc[key] = {
        ...r, // common fields
        punches: [], // repeated fields
      };
    }
    acc[key].punches.push({
      Time: r.Time,
      Type: r.Type,
      ABSENT_DATE: r["ABSENT DATE"],
    });
    return acc;
  }, {});

  const groupedRows = Object.values(groupedData || {});

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* HEADER IMAGE */}
        <View style={styles.headerSpace} fixed>
          {headerImage && (
            <Image src={headerImage} style={styles.header_image} />
          )}
        </View>

        {/* TITLE */}
        <View style={styles.centerDiv}>
          <Text style={styles.mainTitle}>Absence Report</Text>
          <Text style={styles.smallText}>
            Total: {absenceReportPrintData?.length || 0} records
            {/* {"   |   "}Active: {activeCount}
            {"   |   "}Confirmed: {confirmedCount} */}
          </Text>
        </View>

        {/* TABLE HEADER */}
        {/* <View style={styles.tableHeader}>
          <View style={{ flex: COL.empId }}>
            <Text style={styles.cellBold}>Emp ID</Text>
          </View>
          <View style={{ flex: COL.name }}>
            <Text style={styles.cellBold}>Name</Text>
          </View>
          <View style={{ flex: COL.jobTitle }}>
            <Text style={styles.cellBold}>Job Title</Text>
          </View>
          <View style={{ flex: COL.department }}>
            <Text style={styles.cellBold}>Department</Text>
          </View>
          <View style={{ flex: COL.division }}>
            <Text style={styles.cellBold}>Division</Text>
          </View>
          <View style={{ flex: COL.time }}>
            <Text style={styles.cellBold}>Time</Text>
          </View>
          <View style={{ flex: COL.division }}>
            <Text style={styles.cellBold}>Type</Text>
          </View>
        </View> */}

        {/* TABLE ROWS */}
        {/* {absenceReportPrintData?.map((r, idx) => (
          <View key={idx} style={styles.tableRow}>
            <View style={{ flex: COL.empId }}>
              <Text style={styles.cell}>{r["EMP ID"] || "-"}</Text>
            </View>

            <View style={{ flex: COL.name }}>
              <Text style={styles.cellBold}>{r.NAME || "-"}</Text>
            </View>

            <View style={{ flex: COL.jobTitle }}>
              <Text style={styles.cell}>{r["JOB TITLE"] || "-"}</Text>
            </View>

            <View style={{ flex: COL.department }}>
              <Text style={styles.cell}>{r.DEPARTMENT || "-"}</Text>
            </View>

            <View style={{ flex: COL.division }}>
              <Text style={styles.cell}>{r.DIVISION || "-"}</Text>
            </View>
            <View style={{ flex: COL.time }}>
              <Text style={styles.cell}>{r.Time || "-"}</Text>
            </View>
            <View style={{ flex: COL.division }}>
              <Text style={styles.cell}>{r.Type || "-"}</Text>
            </View>
          </View>
        ))} */}

        <View style={styles.tableHeader}>
          <View style={{ flex: COL.empId }}>
            <Text style={styles.cellBold}>Emp ID</Text>
          </View>
          <View style={{ flex: COL.name }}>
            <Text style={styles.cellBold}>Name</Text>
          </View>
          <View style={{ flex: COL.jobTitle }}>
            <Text style={styles.cellBold}>Job Title</Text>
          </View>
          <View style={{ flex: COL.department }}>
            <Text style={styles.cellBold}>Department</Text>
          </View>
          <View style={{ flex: COL.division }}>
            <Text style={styles.cellBold}>Division</Text>
          </View>
          <View style={{ flex: COL.time }}>
            <Text style={styles.cellBold}>Absent Date</Text>
          </View>
        </View>

        {groupedRows?.map((r, idx) => (
          <View
            key={idx}
            style={[
              styles.tableRow,
              { borderBottomWidth: 1, borderBottomColor: "#ccc" },
            ]}
          >
            {/* Common fields — shown once */}
            <View style={{ flex: COL.empId }}>
              <Text style={styles.cell}>{r["EMP ID"] || "-"}</Text>
            </View>
            <View style={{ flex: COL.name }}>
              <Text style={styles.cellBold}>{r.NAME || "-"}</Text>
            </View>
            <View style={{ flex: COL.jobTitle }}>
              <Text style={styles.cell}>{r["JOB TITLE"] || "-"}</Text>
            </View>
            <View style={{ flex: COL.department }}>
              <Text style={styles.cell}>{r.DEPARTMENT || "-"}</Text>
            </View>
            <View style={{ flex: COL.division }}>
              <Text style={styles.cell}>{r.DIVISION || "-"}</Text>
            </View>

            {/* Repeated fields — Time & Type stacked */}
            <View style={{ flex: COL.division, flexDirection: "column" }}>
              {r.punches.map((punch, pIdx) => (
                <View
                  key={pIdx}
                  style={{
                    flexDirection: "row",
                    // borderBottomWidth: pIdx < r.punches.length - 1 ? 1 : 0,
                    borderBottomColor: "#eee",
                    paddingVertical: 2,
                    justifyContent:'center'
                  }}
                >
                  <Text style={styles.cell}>
                    {punch?.ABSENT_DATE
                      ? dayjs(punch.ABSENT_DATE).format("YYYY-MM-DD")
                      : "-"}
                  </Text>
                  {/* ABSENT DATE */}
                </View>
              ))}
            </View>
          </View>
        ))}

        {/* FOOTER IMAGE */}
        {/* <View style={styles.footerSpace} fixed>
          {footerImage && (
            <Image src={footerImage} style={styles.footer_image} />
          )}
          <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
            fixed
          />
        </View>

        
        <View style={styles.footerRow} fixed>
          <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
            fixed
          />
        </View> */}

        <View style={styles.footerSpace} fixed>
          {footerImage && (
            <Image src={footerImage} style={styles.footer_image} />
          )}
        </View>

        {/* PAGE NUMBER — below the image */}
        <Text
          style={styles.footerPageNum}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default AbsenceReportDocument;
